import { createAction } from '@ngrx/store';

export const actionDescName = 'Business Configuration';

export const businessConfigurationChanged = createAction(`[${actionDescName}] - Configuration Changed`);
